export const MAX_VIDEO_SECONDS = 300

export async function captureScreenshotFrame(): Promise<HTMLCanvasElement> {
    const stream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
        audio: false,
        preferCurrentTab: true
    } as DisplayMediaStreamOptions)
    const video = document.createElement('video')
    video.srcObject = stream
    await new Promise<void>((resolve, reject) => {
        video.onloadedmetadata = () => video.play().then(resolve).catch(reject)
        video.onerror = () => reject(new Error('Video load failed'))
    })
    await new Promise((r) => setTimeout(r, 200))
    const canvas = document.createElement('canvas')
    canvas.width = video.videoWidth
    canvas.height = video.videoHeight
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Canvas context not available')
    ctx.drawImage(video, 0, 0)
    stream.getTracks().forEach((t) => t.stop())
    video.srcObject = null
    return canvas
}

export function showCountdown(): Promise<void> {
    return new Promise((resolve) => {
        const overlay = document.createElement('div')
        Object.assign(overlay.style, {
            position: 'fixed',
            inset: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '99999',
            background: 'rgba(0,0,0,0.5)',
            pointerEvents: 'none'
        })

        const label = document.createElement('div')
        Object.assign(label.style, {
            color: '#fff',
            fontSize: '120px',
            fontWeight: 500,
            fontFamily: 'sans-serif',
            lineHeight: '1',
            transition: 'opacity 0.2s ease, transform 0.2s ease'
        })

        overlay.appendChild(label)
        document.body.appendChild(overlay)

        let count = 3
        const tick = () => {
            label.textContent = String(count)
            label.style.opacity = '1'
            label.style.transform = 'scale(1)'
            setTimeout(() => {
                label.style.opacity = '0'
                label.style.transform = 'scale(1.5)'
                count--
                if (count > 0) {
                    setTimeout(tick, 300)
                } else {
                    setTimeout(() => {
                        document.body.removeChild(overlay)
                        resolve()
                    }, 300)
                }
            }, 700)
        }
        tick()
    })
}

export async function captureVideo(stopSignal: Promise<void>): Promise<Blob> {
    const stream = await navigator.mediaDevices.getDisplayMedia({
        video: { cursor: 'always' },
        audio: false,
        preferCurrentTab: true
    } as DisplayMediaStreamOptions)
    await showCountdown()
    const recorder = new MediaRecorder(stream)
    const chunks: Blob[] = []
    recorder.ondataavailable = (e) => e.data.size > 0 && chunks.push(e.data)
    recorder.start()
    await new Promise<void>((resolve) => {
        recorder.onstop = () => {
            stream.getTracks().forEach((t) => t.stop())
            resolve()
        }
        const timeout = setTimeout(() => recorder.stop(), MAX_VIDEO_SECONDS * 1000)
        stopSignal.then(() => {
            clearTimeout(timeout)
            recorder.stop()
        })
    })
    return new Blob(chunks, { type: 'video/webm' })
}
